import axios from "axios";

export default axios.create({
  baseURL: `https://api.up-it.rs`,
});
